<template>
    <div class="contact">
      <h2 class="fs42">联系我们</h2>
      <div class="contact-box">
        <el-row :gutter="10" class="pb50">
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="10" :sm="10" :md="9" :lg="9" :xl="9">
            <div class="int-box"  :class="{ active: isActive1 }">
              <input type="text" @focus="changeActiveTrue1" @blur="changeActiveFalse1" ref="intOne" v-model="intOne" maxlength="10">
              <span class="a-span">名字</span>
              <span class="int-icon">*</span>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="10" :sm="10" :md="9" :lg="9" :xl="9">
            <div class="int-box"  :class="{ active: isActive2 }">
              <input type="text" @focus="changeActiveTrue2" @blur="changeActiveFalse2" ref="intTwo" v-model="intTwo" maxlength="15">
              <span class="a-span">电话</span>
              <span class="int-icon">*</span>
            </div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
        </el-row>
        <el-row :gutter="10" class="pb50">
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="10" :sm="10" :md="9" :lg="9" :xl="9">
            <div class="int-box"  :class="{ active: isActive3 }">
              <input type="text" @focus="changeActiveTrue3" @blur="changeActiveFalse3" ref="intThird" v-model="intThird">
              <span class="a-span">公司名称</span>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="10" :sm="10" :md="9" :lg="9" :xl="9">
            <div class="int-box"  :class="{ active: isActive4 }">
              <input type="text" @focus="changeActiveTrue4" @blur="changeActiveFalse4" ref="intFouth" v-model="intFouth">
              <span class="a-span">邮箱</span>
            </div>
          </el-col>
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
        </el-row>
        <el-row :gutter="10" class="pb50">
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="22" :sm="22" :md="20" :lg="20" :xl="20">
            <span class="a-text">留言：</span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 7}"
              placeholder="请输入内容"
              v-model="textarea">
            </el-input>
          </el-col>
          <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
        </el-row>
        <el-row :gutter="10" class="pb50">
          <el-col :xs="1" :sm="6" :md="6" :lg="6" :xl="6"><div style="height: 10px;"></div></el-col>
          <el-col :xs="22" :sm="12" :md="12" :lg="12" :xl="12">
            <input class="a-int" type="button" @click="postValue()" value="发送">
          </el-col>
          <el-col :xs="1" :sm="6" :md="6" :lg="6" :xl="6"><div style="height: 10px;"></div></el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        intOne: '',
        intTwo: '',
        intThird: '',
        intFouth: '',
        NewNumber:'',
        OldNumber:'',
        textarea:'',
        isActive1: false,
        isActive2: false,
        isActive3: false,
        isActive4: false
      }
    },
    methods: {
      open() {
        this.$message('请勿重覆提交');
      },
      open2() {
        this.$message({
          message: '信息提交成功！',
          type: 'success'
        });
      },
      open3() {
        this.$message({
          message: '请勿重覆提交',
          type: 'warning'
        });
      },
      open4() {
        this.$message('姓名不能为空');
      },
      open5() {
        this.$message('电话不能为空');
      },
      open6() {
        this.$message('电话输入有误');
      },
      open7() {
        this.$message('姓名、电话未输入或输入有误');
      },
      changeActiveTrue1 () {
        this.isActive1=true;
      },
      changeActiveTrue2 () {
        this.isActive2=true;
      },
      changeActiveTrue3 () {
        this.isActive3=true;
      },
      changeActiveTrue4 () {
        this.isActive4=true;
      },
      changeActiveFalse1 () {
        if(this.$refs.intOne.value){
          this.isActive1=true;
          this.name= this.intOne;
        }else{
          this.isActive1=false;
          this.open4();
        }
      },
      changeActiveFalse2 () {
        var that = this;
        if(that.$refs.intTwo.value){
          var aStr = that.intTwo;
          if(!(/^0\d{2,3}-?\d{7,8}$|^1(3|6|4|5|8)[0-9]\d{8}$/.test(aStr))){
            this.open6();
            that.NewNumber = '';
            console.log('我是空'+that.NewNumber);
          }else{
            that.NewNumber = that.intTwo;
          }
          this.isActive2=true;
        }else{

          this.isActive2=false;
          this.open5();
        }
      },
      changeActiveFalse3 () {
        if(this.$refs.intThird.value){
          this.isActive3=true;
        }else{
          this.isActive3=false;
        }
      },
      changeActiveFalse4 () {
        if(this.$refs.intFouth.value){
          this.isActive4=true;
        }else{
          this.isActive4=false;
        }
      },
      // 提交给后台
      postValue () {
        //https://api.douban.com/v2/movie/in_theaters  https://cnodejs.org/api/v1/topics
        if (this.name != '' && this.NewNumber != '' && this.NewNumber != this.OldNumber && this.intOne != '' && this.intTwo != '') {
          this.OldNumber = this.NewNumber;
          var url = 'http://www.zfgc.cn/ms/website/MassageBoard/addMessageBoard';
          var json = {
            name: this.name,
            phone: this.NewNumber,
            companyname: this.intThird,
            eail: this.intFouth,
            messageboard: this.textarea
          }
          this.axios({
            method: 'post',
            url: url,
            data: json,
            header: {
              'content-type': 'application/json'
            },
          }).then(function (res) {
            console.log(res);
          }).catch(function (err) {
            console.log(err);
          });
          console.log(json);
          this.open2();
        } else if(this.NewNumber != '' && this.NewNumber == this.OldNumber){
          this.open3();
        } else{
          this.open7();
        }
      }
    }
  }
</script>
<style scoped>
  .contact{
    position: relative;
    width: 100%;
    background: url("../../../../static/images/12.png") no-repeat center ;
    background-size: cover;
    padding-bottom: 80px;
  }
  .contact-box{
    max-width: 800px;
    height: auto;
    margin: 0 auto;
    padding-top: 50px;
    background: #ffffff;
    box-shadow: 0 10px 20px 0 #eee ;
  }
  .contact h2 {
    text-align: center;
    padding: 80px 0 60px 0;
  }
  .fs42 {
    font-size: 42px;
  }
  .int-box{
    position: relative;
    width: 100%;
    height: 38px;
  }
  .int-box input{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    outline:none;
    line-height: 38px;
    font-size: 18px;
    color: #666;
  }
  .int-box input{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    outline:none;
    border-bottom: 1px solid #e6e6e6;
    line-height: 38px;
    font-size: 18px;
    color: #666;
    transition: all .8s;
  }
  .int-box input:focus{
    border-bottom: 1px solid #666666;
  }

  .a-span{
    position: absolute;
    left: 0;
    top: 0;
    line-height:38px;
    color: #666;
    font-size: 18px;
    z-index: 1;
    transition: all .8s;
  }
  .active .a-span{
    left: 0;
    top:-25px;
    font-size: 14px;
    color: #888;
  }
  .int-icon{
    position: absolute;
    right: 10%;
    top: 10px;
    color: #ff574e;
    font-size: 20px;
  }
  .a-text{
    display: block;
    color: #666;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .a-int{
    width: 100%;
    height: 60px;
    background: #ff574e;
    color: #FFF;
    font-size: 24px;
    border-radius: 6px;
  }
  .pb50{
    padding-bottom:50px;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .contact h2 {
      text-align: center;
      padding: 60px 0;
    }
    .fs42 {
      font-size: 36px;
    }
    .contact{
      padding-bottom: 60px;
    }
    .contact-box{
      padding-top: 40px;
    }
    .pb50{
      padding-bottom:40px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 16px;
    }
    .a-int{
      height: 50px;
      font-size: 20px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .contact h2 {
      text-align: center;
      padding: 40px 0;
    }
    .fs42 {
      font-size: 30px;
    }
    .contact{
      padding-bottom: 40px;
    }
    .contact-box{
      padding-top: 30px;
    }
    .pb50{
      padding-bottom:30px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 14px;
    }
    .a-int{
      height: 40px;
      font-size: 18px;
    }
  }
  @media screen and (max-width: 767px){
    .contact h2 {
      text-align: center;
      padding: 27px 0;
      font-size: 20px;
      line-height: 24px;
    }
    .fs42 {
      font-size: 24px;
    }
    .contact{
      padding-bottom: 30px;
    }
    .contact-box{
      padding-top: 5px;
    }
    .pb50{
      padding-bottom:20px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 13px;
    }
    .a-int{
      height: 40px;
      font-size: 16px;
    }
  }
  @media (min-width: 768px){

  }
</style>




// WEBPACK FOOTER //
// src/components/index/contactUs/contactUs.vue